export default "/images/maxidom.png?c58ce67ce5d482fd31d6769c2795d7af";